import { render, staticRenderFns } from "./InstaGallery.vue?vue&type=template&id=0b2fafce&scoped=true"
import script from "./InstaGallery.vue?vue&type=script&lang=js"
export * from "./InstaGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2fafce",
  null
  
)

export default component.exports